var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	4253: {
		fallback: ()=>()=>{throw new Error("Can not get 'react'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	5182: {
		fallback: () => (__webpack_require__.e(387).then(() => (() => (__webpack_require__(5387))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-is",

	},
	1750: {
		fallback: ()=>()=>{throw new Error("Can not get 'react-dom'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	1662: {
		fallback: () => (__webpack_require__.e(158).then(() => (() => (__webpack_require__(9777))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.3.10",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",

	},
	3098: {
		fallback: () => (Promise.all([__webpack_require__.e(153), __webpack_require__.e(750)]).then(() => (() => (__webpack_require__(8153))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "4.10.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"35": [
		1662,
		3098
	],
	"182": [
		5182
	],
	"253": [
		4253
	],
	"750": [
		1750
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}